import Entity from '../entity';
export default class FlightRoute extends Entity<string> {
  origin: string;
  destination: string;
  departureDates: string;
}
